import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuthServiceProvider } from '../../api/auth'

const AuthService = AuthServiceProvider()
const name = 'setPassword'

export default (userName, newPassword, confirmPassword) => (asyncAction(
  name,
  AuthService.setPassword,
  { userName, newPassword, confirmPassword }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/setPassword.js